import { HelpService } from './../../help/help.service';
import { HomeComponent } from './../home.component';
import { SettingsService } from './../../settings/settings.service';
import { KpiData } from './../models/kpi-data.model';
import { Component, ElementRef, HostListener, Input, OnInit, OnDestroy, ViewChild, ChangeDetectorRef } from '@angular/core';
import { KpiCaptiondata, KpiObjectData } from '../models/kpi-object-data.model';
import { NotificationService } from 'src/app/services/notification.service';
import { ForecastService } from '../../forecast/forecast.service';
import ResizeObserver from 'resize-observer-polyfill';


@Component({
    selector: 'app-kpi-card',
    templateUrl: './kpi-card.component.html',
    styleUrls: ['./kpi-card.component.scss'],
    standalone: false
})
export class KpiCardComponent implements OnInit, OnDestroy {
	@Input() public homeComponent: HomeComponent;
	@Input() public kpiObject: KpiObjectData;
	@Input() public kpicap: KpiCaptiondata[];

	public perserveTooltipEnabled: boolean;

	public toggleTooltipPerservation() {
		this.perserveTooltipEnabled = !this.perserveTooltipEnabled;
	}

	public disableTooltipPerservation() {
		this.perserveTooltipEnabled = false;
	}

	public tooltipVisible: boolean;

	public enableTooltip() {
		this.tooltipVisible = true;
	}

	public disableTooltip() {
		if (!this.perserveTooltipEnabled) {
			this.tooltipVisible = false;
		}
	}

	public lineChartFields: { name: string, value: string }[] = [
		{ name: "Quantity", value: "Qty" },
	];

	public lineChartDataSource: KpiData[] = [];

	public lastPeriodKpiData: KpiData = new KpiData();

	public reload: boolean;

	private _reload() {
		setTimeout(() => this.reload = false);
		setTimeout(() => this.reload = true);
	}

	@ViewChild("card", { static: false }) public card: ElementRef;

	private _observer: ResizeObserver;

	constructor(
		private notificationService: NotificationService,
		private forecastService: ForecastService,
		private settingsService: SettingsService,
		private changeDetectorRef: ChangeDetectorRef,
		private host: ElementRef,
		private helpService: HelpService,
	) { }

	ngOnInit() {
		this.initializeChartData();
		this.kpiObject = Object.assign(new KpiObjectData(), this.kpiObject);
		this.kpiObject.Initialize();
		setTimeout(() => {
			this._reload();
		}, 1000);
	}





	ngOnDestroy() {
		
	}

	public initializeChartData() {
		const $this = this;
		

		this.forecastService.getKpi(this.kpiObject.kpiId, this.kpiObject.chartNumberOfEntries).subscribe(
			(response) => {
				$this.lineChartDataSource = response;

				for (let a = 0; a < $this.lineChartDataSource.length; a++) {
					$this.lineChartDataSource[a].Period = $this.lineChartDataSource[a].Period.toString();
				}

				$this.lastPeriodKpiData = $this.lineChartDataSource[$this.lineChartDataSource.length - 1];

				$this._reload();

				
			},
			(error) => {
				console.error(error);

				

				$this.notificationService.error(error);
			}
		);
	}

	// <Styling>

	public getMainValueIconContainerTransform(): string {
		//return `rotate(${this.lastPeriodKpiData.ArrowDirection === 1 ? "0deg" : this.lastPeriodKpiData.ArrowDirection === 0 ? "90deg" : "180deg"}) scale(1, 1.25)`;
		let rotation: string;

		if (this.lastPeriodKpiData.ArrowDirection === 1) {
			rotation = "0deg";
		} else if (this.lastPeriodKpiData.ArrowDirection === 0) {
			rotation = "90deg";
		} else {
			rotation = "180deg";
		}

		return `rotate(${rotation}) scale(1, 1.25)`;
	}

	public getMainValueIconColor(): string {
		

		//let colorValue = this.lastPeriodKpiData.ArrowDirection === 0 ? 0 : (this.kpiObject.positiveIsGood ? (this.lastPeriodKpiData.ArrowDirection === 1 ? 1 : -1) : (this.lastPeriodKpiData.ArrowDirection === -1 ? 1 : -1));
		let colorValue: number;

		if (this.lastPeriodKpiData.ArrowDirection === 0) {
			colorValue = 0;
		} else {
			if (this.kpiObject.positiveIsGood) {
				if (this.lastPeriodKpiData.ArrowDirection === 1) {
					colorValue = 1;
				} else {
					colorValue = -1;
				}
			} else {
				if (this.lastPeriodKpiData.ArrowDirection === -1) {
					colorValue = 1;
				} else {
					colorValue = -1;
				}
			}
		}

		if (this.homeComponent.arrowColorValues.has(colorValue)) {
			return this.homeComponent.arrowColorValues.get(colorValue);
		}

		return "grey";
	}

	// </Styling>

	public onHelpButtonClicked(event) {
		console.log("onHelpButtonClicked - event:", event);

		this.helpService.openHelpPageById(this.kpiObject.helpPageId);

		
	}

	@HostListener('window:resize', ['$event'])
	onResize(event) {
		this._reload();

		
	}



	// <Misc>

	public getKeys(object: any) {
		return Object.keys(object);
	}

	// </Misc>
}
